import { render, staticRenderFns } from "./DangerHiddenDetail.vue?vue&type=template&id=11594031&scoped=true"
import script from "./DangerHiddenDetail.vue?vue&type=script&lang=js"
export * from "./DangerHiddenDetail.vue?vue&type=script&lang=js"
import style0 from "./DangerHiddenDetail.vue?vue&type=style&index=0&id=11594031&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11594031",
  null
  
)

export default component.exports